import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/api/endpoints";
import { useSession } from "@/store/session";
import { Bismillah } from "./Bismillah";
import { ThemeToggle } from "./ThemeToggle";
import { Wordmark } from "./Wordmark";

export function PublicNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = useSession((s) => s.email);
  const isValid = useSession((s) => s.isValid());
  const clear = useSession((s) => s.clear);
  const session = isValid ? email : null;

  const path = location.pathname;
  const isAbout = path === "/about";
  const showBismillah = path === "/" || path === "/about" || path === "/login" || path === "/register";
  const handleLogout = () => {
    const refreshToken = useSession.getState().refreshToken;
    if (refreshToken) void api.auth.logout({ refresh_token: refreshToken }).catch(() => {});
    clear();
    navigate("/");
  };

  return (
    <nav className={`sa-public-nav${session ? " sa-public-nav--authed" : ""}`}>
      <div className="sa-public-nav__brand-row">
        <Wordmark onClick={() => navigate("/")} />
        {session && (
          <button
            type="button"
            onClick={handleLogout}
            className="sa-btn sa-btn--ghost sa-public-nav__mobile-logout"
          >
            Log out
          </button>
        )}
      </div>
      <div className="sa-public-nav__blessing">
        <Bismillah show={showBismillah} />
      </div>
      <div className="sa-public-nav__actions">
        <ThemeToggle />
        <a
          onClick={() => navigate("/about")}
          className="sa-public-nav__link"
          style={{
            color: isAbout ? "var(--sa-accent)" : "var(--sa-fg)",
          }}
        >
          About
        </a>
        {session ? (
          <>
            <a
              onClick={() => navigate("/chat")}
              className="sa-public-nav__link"
              style={{ color: "var(--sa-fg)" }}
            >
              Chat
            </a>
            <span className="sa-public-nav__session">{session}</span>
            <button
              onClick={handleLogout}
              className="sa-btn sa-btn--ghost sa-public-nav__logout"
              style={{
                padding: "8px 14px",
                fontSize: 12,
                color: "var(--sa-accent)",
                borderColor: "var(--sa-accent)",
                background: "var(--sa-accent-soft)",
              }}
            >
              Log out
            </button>
          </>
        ) : (
          <>
            <a
              onClick={() => navigate("/login")}
              className="sa-public-nav__link"
              style={{ color: "var(--sa-fg)" }}
            >
              Sign in
            </a>
            <button className="sa-btn" onClick={() => navigate("/register")}>
              Create account
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
